import { rest } from 'msw';

import { ALL_ASSETS_MULTIPLE_MOCK, ALL_ASSETS_SINGLE_MOCK } from './all-assets.mock';
import { CURRENCIES_RESPONSE_MOCK } from './currencies-response.mock';
import { DAILY_DEALS_MOCK } from './daily-deals.mock';
import {
  DAILY_REWARDS_CALENDAR_MOCK,
  DAILY_REWARDS_CLAIM_MOCK,
  DAILY_REWARDS_HISTORY_MOCK,
} from './daily-rewards.mock';
import { NFT_YIELDS_MOCK } from './nft-yields.mock';
import { NFT_OF_THE_DAY_MOCK } from './nft-of-the-day.mock';
import { NFT_OF_THE_WEEK_MOCK } from './nft-of-the-week.mock';
import { TOP_OFFERS_MOCK } from './top-offers.mock';

export const handlers = [
  rest.get('/api/v1/trades/daily_deals', (req, res, ctx) => {
    return res(ctx.delay(350), ctx.status(200), ctx.json(DAILY_DEALS_MOCK));
  }),

  rest.get('/api/v1/trades/top_offers', (req, res, ctx) => {
    return res(ctx.delay(350), ctx.status(200), ctx.json(TOP_OFFERS_MOCK));
  }),

  rest.get('/api/v1/trades/nft_of_the_day', (req, res, ctx) => {
    return res(ctx.delay(350), ctx.status(200), ctx.json(NFT_OF_THE_DAY_MOCK));
  }),

  rest.get('/api/v1/trades/nft_of_the_week', (req, res, ctx) => {
    return res(ctx.delay(350), ctx.status(200), ctx.json(NFT_OF_THE_WEEK_MOCK));
  }),

  rest.get('/api/v1/assets/all_assets', (req, res, ctx) => {
    const ids = req.url.searchParams.get('ids');

    if (ids === '84') {
      return res(ctx.delay(350), ctx.status(200), ctx.json(ALL_ASSETS_SINGLE_MOCK));
    }

    if (ids === '1050,750,582,720') {
      return res(ctx.delay(350), ctx.status(200), ctx.json(ALL_ASSETS_MULTIPLE_MOCK));
    }

    // Default fallback - return empty array if ids don't match
    return res(ctx.delay(350), ctx.status(200), ctx.json([]));
  }),

  rest.get('/api/v1/assets/currencies/', (req, res, ctx) => {
    return res(ctx.delay(350), ctx.status(200), ctx.json(CURRENCIES_RESPONSE_MOCK));
  }),

  rest.get('/api/v1/daily-login/calendar/', (req, res, ctx) => {
    return res(ctx.delay(500), ctx.status(200), ctx.json(DAILY_REWARDS_CALENDAR_MOCK));
  }),

  rest.post('/api/v1/daily-login/claim/', (req, res, ctx) => {
    return res(ctx.delay(800), ctx.status(200), ctx.json(DAILY_REWARDS_CLAIM_MOCK));
  }),

  rest.get('/api/v1/daily-login/history/', (req, res, ctx) => {
    return res(ctx.delay(500), ctx.status(200), ctx.json(DAILY_REWARDS_HISTORY_MOCK));
  }),

  rest.get('/express-proxy/insight/nft-yields', (req, res, ctx) => {
    return res(ctx.delay(200), ctx.status(200), ctx.json(NFT_YIELDS_MOCK));
  }),
];
